<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mr-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Edit Daycare Career Request
        </v-card-title>
        <page-loader :loading="isFetching" />
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.full_name"
                outlined
                readonly
                hide-details="auto"
                label="Full Name"
                prepend-inner-icon="mdi-account"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.date_of_birth"
                outlined
                readonly
                hide-details="auto"
                label="Date of Birth"
                prepend-inner-icon="mdi-calendar"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.phone_no"
                outlined
                readonly
                hide-details="auto"
                label="Phone Number"
                prepend-inner-icon="mdi-phone"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.email"
                outlined
                readonly
                hide-details="auto"
                label="Email"
                prepend-inner-icon="mdi-email"
              ></v-text-field>
            </v-col>
            <v-col sm="8">
              <v-textarea
                v-model="form.address"
                outlined
                readonly
                hide-details="auto"
                label="Address"
                prepend-inner-icon="mdi-map-marker"
              ></v-textarea>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.pin_code"
                outlined
                readonly
                hide-details="auto"
                label="Pin Code"
                prepend-inner-icon="mdi-map-marker-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="genderText"
                outlined
                readonly
                hide-details="auto"
                label="Gender"
                prepend-inner-icon="mdi-gender-male-female"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="workTypeText"
                outlined
                readonly
                hide-details="auto"
                label="Preferred Work Type"
                prepend-inner-icon="mdi-briefcase-variant"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.available_on"
                outlined
                readonly
                hide-details="auto"
                label="Available On"
                prepend-inner-icon="mdi-calendar-check"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.preferred_timeslot"
                outlined
                readonly
                hide-details="auto"
                label="Preferred Timeslot"
                prepend-inner-icon="mdi-clock"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="pickupDropText"
                outlined
                readonly
                hide-details="auto"
                label="Open to Pickup/Drop"
                prepend-inner-icon="mdi-car"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="experienceText"
                outlined
                readonly
                hide-details="auto"
                label="Is Experienced"
                prepend-inner-icon="mdi-star"
              ></v-text-field>
            </v-col>
            <v-col sm="8">
              <v-textarea
                v-model="form.experience_description"
                outlined
                readonly
                hide-details="auto"
                label="Experience Description"
                prepend-inner-icon="mdi-text"
              ></v-textarea>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="dayCarExperienceText"
                outlined
                readonly
                hide-details="auto"
                label="Experienced in Day Care"
                prepend-inner-icon="mdi-home-heart"
              ></v-text-field>
            </v-col>
            <v-col sm="8">
              <v-textarea
                v-model="form.experienced_day_care_description"
                outlined
                readonly
                hide-details="auto"
                label="Day Care Experience Description"
                prepend-inner-icon="mdi-text"
              ></v-textarea>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="comfortableWithSizesText"
                outlined
                readonly
                hide-details="auto"
                label="Comfortable with Sizes"
                prepend-inner-icon="mdi-resize"
              ></v-text-field>
            </v-col>
            <v-col sm="8">
              <v-textarea
                v-model="form.commfortable_description"
                outlined
                readonly
                hide-details="auto"
                label="Comfort Description"
                prepend-inner-icon="mdi-text"
              ></v-textarea>
            </v-col>
            <v-col sm="8">
              <v-textarea
                v-model="form.additional_description"
                outlined
                readonly
                hide-details="auto"
                label="Additional Description"
                prepend-inner-icon="mdi-text"
              ></v-textarea>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="allergiesText"
                outlined
                readonly
                hide-details="auto"
                label="Has Allergies"
                prepend-inner-icon="mdi-alert-circle"
              ></v-text-field>
            </v-col>
            <v-col sm="8" v-if="form.has_allergies">
              <v-textarea
                v-model="form.allergies_details"
                outlined
                readonly
                hide-details="auto"
                label="Allergies Details"
                prepend-inner-icon="mdi-text"
              ></v-textarea>
            </v-col>
            <v-col lg="4" md="4" sm="4" cols="12">
              <v-autocomplete
                v-model="form.status"
                outlined
                hide-details="auto"
                :items="statusItems"
                label="Status"
                prepend-inner-icon="mdi-checkbox-marked-circle-outline"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_active"
                inset
                :label="`Is Active: ${form.is_active ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
          </v-row>
          
          <!-- References Section -->
          <v-divider class="my-5"></v-divider>
          <h3 class="mb-4">References</h3>
          <v-row v-for="(reference, index) in form.daycare_career_request_references" :key="index">
            <v-col sm="4">
              <v-text-field
                v-model="reference.full_name"
                outlined
                readonly
                hide-details="auto"
                :label="`Reference ${index + 1} - Full Name`"
                prepend-inner-icon="mdi-account"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="reference.relation"
                outlined
                readonly
                hide-details="auto"
                :label="`Reference ${index + 1} - Relation`"
                prepend-inner-icon="mdi-account-group"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="reference.contact"
                outlined
                readonly
                hide-details="auto"
                :label="`Reference ${index + 1} - Contact`"
                prepend-inner-icon="mdi-phone"
              ></v-text-field>
            </v-col>
          </v-row>
          
          <v-divider class="my-5"> </v-divider>
          <v-btn v-can:edit="'daycare_requests'"
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Update Daycare Career Request
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";

export default {
  name: "DaycareCareerRequestEditPage",
  data() {
    return {
      form: {
        is_active: false,
        daycare_career_request_references: []
      },
      statusItems: [
        { id: "PENDING", text: "PENDING", value: 0 },
        { id: "APPROVED", text: "APPROVED", value: 1 },
        { id: "REJECTED", text: "REJECTED", value: 2 },
      ],
      isLoading: false,
      isFetching: false,
    };
  },
  computed: {
    genderText() {
      if (this.form.gender === 0) return 'Male';
      if (this.form.gender === 1) return 'Female';
      if (this.form.gender === 2) return 'Other';
      return 'Not specified';
    },
    workTypeText() {
      if (this.form.preferred_work_type === 0) return 'Full Time';
      if (this.form.preferred_work_type === 1) return 'Part Time';
      if (this.form.preferred_work_type === 2) return 'Freelance';
      return 'Not specified';
    },
    pickupDropText() {
      return this.form.open_to_pickup_drop ? 'YES' : 'NO';
    },
    experienceText() {
      return this.form.is_experienced ? 'YES' : 'NO';
    },
    dayCarExperienceText() {
      return this.form.is_experienced_day_care ? 'YES' : 'NO';
    },
    comfortableWithSizesText() {
      return this.form.is_commfortable_with_sizes ? 'YES' : 'NO';
    },
    allergiesText() {
      return this.form.has_allergies ? 'YES' : 'NO';
    }
  },
  async mounted() {
    this.isFetching = true;
    try {
      await this.getData();
    } finally {
      this.isFetching = false;
    }
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.daycareCareerRequestId;
      axios
        .get(`/daycare_career_requests/${encryptedId}`)
        .then((response) => {
          this.form = response.data.data;
          this.old_json = response.data.data;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      this.isLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        console.log(this.form);
        await axios
          .patch(`/daycare_career_requests/${this.$route.params.daycareCareerRequestId}`, this.form)
          .then(async () => {
            await this.saveUserTimestamp(this.old_json, this.form);
            this.$router.push("/daycare-career-requests");
          })
          .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
      }
    },
  },
};
</script>